import React from 'react'
import { JURISDICCIONES_DISPONIBLES } from '../services/tasasInteresService'
import Tooltip from './Tooltip'
import { FIELD_TOOLTIPS } from '../utils/fieldTooltips'

export default function EstrategiaJudicialSection({
  modoHerramienta,
  expediente,
  setExpediente,
  jurisdiccion,
  setJurisdiccion,
  fechaCeseEstimada,
  setFechaCeseEstimada,
  fechaCeseSugerida,
  goBack,
  goNext,
  step3Valid,
  wizardStageABValid,
  blockingIssuesStageA,
  blockingIssuesStageB,
  modoCaso,
  caseValidation,
  activeRules,
  parseMontoValue,
}) {
  return (
    <section className="panel-profile-accent rounded-xl p-4">
      <p className="mb-1 text-xs uppercase tracking-wide text-profile-accent">Tarjeta 3 - Estrategia Judicial</p>
      {blockingIssuesStageA.length > 0 && (
        <div className="mb-3 rounded-lg border border-rose-300/50 bg-rose-500/20 p-3 text-xs text-rose-100">
          <p className="font-semibold uppercase tracking-wide">Errores bloqueantes - Etapa A (Régimen)</p>
          <ul className="mt-1 list-disc pl-4">
            {blockingIssuesStageA.map((issue, idx) => <li key={`a-${idx}`}>{issue}</li>)}
          </ul>
        </div>
      )}
      <div className="mb-2">
        <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${modoCaso.badgeClass}`}>
          {modoCaso.label}
        </span>
      </div>
      {modoHerramienta === 'avanzado' ? (
        <p className="mb-3 text-xs text-cyan-50/90">Definí parámetros legales y económicos del caso: índice, cese y haber actual para calcular diferencial y retroactivo.</p>
      ) : (
        <p className="mb-3 text-xs text-cyan-50/90">Definí la fecha de cese para calcular el haber estimado base.</p>
      )}
      {modoHerramienta === 'avanzado' && (
      <div className="mb-3 rounded-lg border border-white/20 bg-slate-900/40 p-2 text-xs text-slate-200">
        <label className="inline-flex items-center gap-2">
          <input type="checkbox" checked={Boolean(expediente.esDocente)} onChange={(e) => setExpediente((p) => ({ ...p, esDocente: e.target.checked }))} />
          Configurar como Régimen Especial Docente (Dec. 137/05)
        </label>
        <label className="mt-2 inline-flex items-center gap-2">
          <input type="checkbox" checked={Boolean(expediente.tieneBeneficioPrevio)} onChange={(e) => setExpediente((p) => ({ ...p, tieneBeneficioPrevio: e.target.checked }))} />
          Ya posee beneficio otorgado
        </label>
        {Boolean(expediente.esDocente) && (
          <p className="mt-2 rounded border border-cyan-300/40 bg-cyan-500/15 p-2 text-[11px] text-cyan-100">
            Caso híbrido sugerido (Docente + empleo civil): activá Docente si la estrategia busca 82% móvil.
            Luego validá simultaneidad en Tarjeta 4 para evitar sobrecómputo de días y confirmar montos por CUIT.
          </p>
        )}
      </div>
      )}
      {modoHerramienta === 'avanzado' && (
      <div className="mb-3 rounded-lg border border-white/20 bg-slate-900/40 p-2 text-xs text-slate-200">
        <p className="mb-2 font-semibold text-profile-accent">Contingencia Pensión</p>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-4">
          <select value={expediente?.datosPension?.tipoPension || ''} onChange={(e) => setExpediente((p) => ({ ...p, datosPension: { ...(p.datosPension || {}), tipoPension: e.target.value } }))} className="h-10 rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white">
            <option value="">Sin pensión</option>
            <option value="DERIVADA">Pensión derivada</option>
            <option value="DIRECTA">Pensión directa</option>
          </select>
          <input type="date" value={expediente?.datosPension?.fechaFallecimiento || ''} onChange={(e) => setExpediente((p) => ({ ...p, datosPension: { ...(p.datosPension || {}), fechaFallecimiento: e.target.value } }))} className="h-10 rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
          <input type="text" inputMode="decimal" placeholder="Haber causante (si derivada)" value={expediente?.datosPension?.haberJubiladoCausante || ''} onChange={(e) => setExpediente((p) => ({ ...p, datosPension: { ...(p.datosPension || {}), haberJubiladoCausante: parseMontoValue(e.target.value) } }))} className="h-10 rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
          <input type="number" min="0" placeholder="Hijos con derecho" value={Number(expediente?.datosPension?.concurrentes?.hijosCount || 0)} onChange={(e) => setExpediente((p) => ({ ...p, datosPension: { ...(p.datosPension || {}), concurrentes: { ...(p?.datosPension?.concurrentes || {}), hijosCount: Number(e.target.value || 0) } } }))} className="h-10 rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
        </div>
        <label className="mt-2 inline-flex items-center gap-2 text-xs text-slate-200">
          <input
            type="checkbox"
            checked={Boolean(expediente?.datosPension?.concurreConyugeConviviente !== false)}
            onChange={(e) => setExpediente((p) => ({
              ...p,
              datosPension: {
                ...(p.datosPension || {}),
                concurreConyugeConviviente: e.target.checked,
                concurrentes: {
                  ...(p?.datosPension?.concurrentes || {}),
                  conyuge: e.target.checked,
                },
              },
            }))}
          />
          Concurre cónyuge/conviviente previsional
        </label>
        {String(activeRules?.caseMeta?.scenarioKey || '') === 'PENSION_DIRECTA' && activeRules?.caseMeta?.criterioRegularidad && (
          <div className="mt-2 rounded border border-white/15 bg-white/5 p-2 text-[11px] text-slate-200">
            <p>Diagnóstico regularidad (Dec. 460/99):</p>
            <p>M36: {Number(activeRules.caseMeta.criterioRegularidad?.mesesAportados36 || 0)} | M60: {Number(activeRules.caseMeta.criterioRegularidad?.mesesAportados60 || 0)}</p>
            <p>Condición legal: {String(activeRules.caseMeta.criterioRegularidad?.condicionLegal || 'N/D')} | Factor IB: {Number((Number(activeRules.caseMeta.criterioRegularidad?.factorQuita || 0) * 100)).toFixed(2)}%</p>
          </div>
        )}
      </div>
      )}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Jurisdicción (define tasa sugerida)</label>
          <select title="Define criterios de tasa de interés y perfil litigioso." value={jurisdiccion} onChange={(e) => setJurisdiccion(e.target.value)} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white">
            {(JURISDICCIONES_DISPONIBLES || []).map((j) => <option key={j.value} value={j.value}>{j.label}</option>)}
          </select>
        </div>
        )}
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Fecha de Cese Real (corte legal)</label>
          <input title="Fecha real de cese de actividad para fijar base legal e índice." type="date" value={expediente.fechaCese} onChange={(e) => setExpediente((p) => ({ ...p, fechaCese: e.target.value }))} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
          {fechaCeseSugerida && (
            <div className="mt-1 flex items-center gap-2 text-[11px] text-slate-300">
              <span>Sugerida por PDF: {fechaCeseSugerida}</span>
              <button type="button" onClick={() => setExpediente((p) => ({ ...p, fechaCese: fechaCeseSugerida }))} className="rounded border border-white/25 px-2 py-0.5 text-[10px] text-white">Usar sugerida</button>
            </div>
          )}
        </div>
        {blockingIssuesStageB.length > 0 && (
          <div className="md:col-span-3 rounded-lg border border-rose-300/50 bg-rose-500/20 p-3 text-xs text-rose-100">
            <p className="font-semibold uppercase tracking-wide">Errores bloqueantes - Etapa B (Fechas)</p>
            <ul className="mt-1 list-disc pl-4">
              {blockingIssuesStageB.map((issue, idx) => <li key={`b-${idx}`}>{issue}</li>)}
            </ul>
          </div>
        )}
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Cese Estimado (escenario proyectado)</label>
          <input type="month" value={fechaCeseEstimada} onChange={(e) => setFechaCeseEstimada(e.target.value)} title="Permite simular meses futuros para escenario proyectado." className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
        </div>
        )}
        {modoHerramienta === 'avanzado' ? (
          <div>
            <label className="mb-1 block text-[11px] text-profile-accent">Índice/Fallo aplicable</label>
            <select title="Selecciona la doctrina de actualización a aplicar en el caso." value={caseValidation?.derivedStrategy?.lockUserChoice ? String(caseValidation?.derivedStrategy?.indice || expediente.fallo || '') : expediente.fallo} disabled={Boolean(caseValidation?.derivedStrategy?.lockUserChoice)} onChange={(e) => setExpediente((p) => ({ ...p, fallo: e.target.value }))} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white disabled:cursor-not-allowed disabled:opacity-70">
              <option>ISBIC</option><option>RIPTE</option><option>IPC</option>
              {caseValidation?.derivedStrategy?.lockUserChoice && (
                <option value={String(caseValidation?.derivedStrategy?.indice || '')}>{String(caseValidation?.derivedStrategy?.indice || '')}</option>
              )}
            </select>
            {caseValidation?.derivedStrategy?.lockUserChoice && (
              <p className="mt-1 text-[11px] text-amber-200">
                Índice fijado automáticamente por el régimen seleccionado (Razón: {String(caseValidation?.derivedStrategy?.reason || 'estrategia derivada obligatoria')}).
              </p>
            )}
          </div>
        ) : (
          <div>
            <label className="mb-1 block text-[11px] text-profile-accent">Método de cálculo</label>
            <div className="panel-profile-ok h-10 w-full rounded-xl px-3 text-xs font-semibold leading-10 text-profile-ok">
              Base administrativa neutral (sin fallos)
            </div>
          </div>
        )}
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Haber mensual que percibe hoy (opcional)</label>
          <input title="Si no se informa, el sistema usa haber minimo legal para estimacion." type="text" inputMode="decimal" value={expediente.haberActual} onChange={(e) => setExpediente((p) => ({ ...p, haberActual: parseMontoValue(e.target.value) }))} placeholder="Haber mensual que percibe hoy" className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white placeholder:text-slate-300" />
          {!(Number(expediente.haberActual || 0) > 0) && <p className="mt-1 text-[11px] text-amber-200">Haber percibido no informado. Se calcula perjuicio estimado sobre haber minimo legal.</p>}
        </div>
        )}
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Fecha de alta del beneficio {expediente.tieneBeneficioPrevio ? '(requerida)' : '(opcional)'}</label>
          <input type="date" value={expediente.fechaOtorgamientoBeneficio || ''} onChange={(e) => setExpediente((p) => ({ ...p, fechaOtorgamientoBeneficio: e.target.value }))} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
        </div>
        )}
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Fecha reclamo administrativo</label>
          <input type="date" value={expediente.fechaReclamoAdministrativo || ''} onChange={(e) => setExpediente((p) => ({ ...p, fechaReclamoAdministrativo: e.target.value }))} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
        </div>
        )}
        {modoHerramienta === 'avanzado' && (
        <div>
          <label className="mb-1 block text-[11px] text-profile-accent">Fecha denegatoria o demanda</label>
          <input type="date" value={expediente.fechaDenegatoriaODemanda || ''} onChange={(e) => setExpediente((p) => ({ ...p, fechaDenegatoriaODemanda: e.target.value }))} className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white" />
        </div>
        )}
        {modoHerramienta === 'avanzado' && (Boolean(expediente.esDocente) || String(activeRules?.caseMeta?.scenarioKey || '').includes('DOCENTE')) && (
          <>
            <div>
              <label className="mb-1 block text-[11px] text-profile-accent">Denominación del cargo al cese</label>
              <input
                type="text"
                value={expediente?.datosDocentes?.cargoCese || ''}
                onChange={(e) => setExpediente((p) => ({ ...p, datosDocentes: { ...(p.datosDocentes || {}), cargoCese: e.target.value } }))}
                placeholder="Profesor de Enseñanza Media - 30 horas"
                className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white"
              />
            </div>
            <div>
              <label className="mb-1 block text-[11px] text-profile-accent">
                <Tooltip text={FIELD_TOOLTIPS.sueldoBrutoCargoCese.tooltipText}>
                  <span>Remuneración Bruta Total al Cese (Suma de Cargos Docentes Simultáneos)</span>
                </Tooltip>
              </label>
              <input
                type="text" inputMode="decimal"
                value={expediente?.datosDocentes?.sueldoBrutoCargoCese || ''}
                onChange={(e) => setExpediente((p) => ({ ...p, datosDocentes: { ...(p.datosDocentes || {}), sueldoBrutoCargoCese: parseMontoValue(e.target.value) } }))}
                className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white"
              />
            </div>
            <div>
              <label className="mb-1 block text-[11px] text-profile-accent">Continuidad en el cargo</label>
              <select
                value={Number(expediente?.datosDocentes?.mesesEnCargoContinuos || 0) >= 60 ? 'CONTINUOS_60' : Number(expediente?.datosDocentes?.mesesEnCargoAlternados || 0) >= 120 ? 'ALTERNADOS_120' : ''}
                onChange={(e) => {
                  const val = e.target.value
                  setExpediente((p) => ({
                    ...p,
                    datosDocentes: {
                      ...(p.datosDocentes || {}),
                      mesesEnCargoContinuos: val === 'CONTINUOS_60' ? 60 : 0,
                      mesesEnCargoAlternados: val === 'ALTERNADOS_120' ? 120 : 0,
                    },
                  }))
                }}
                className="h-10 w-full rounded-xl border border-white/25 bg-slate-900/60 px-3 text-white"
              >
                <option value="">Seleccionar</option>
                <option value="CONTINUOS_60">60 o mas meses continuos</option>
                <option value="ALTERNADOS_120">120 o mas meses alternados</option>
              </select>
            </div>
          </>
        )}
      </div>
      <div className="mt-4 flex items-center justify-between">
        <button type="button" onClick={goBack} className="panel-profile rounded-xl px-4 py-2 text-sm font-semibold">Anterior</button>
        <button type="button" disabled={!step3Valid || !wizardStageABValid} onClick={goNext} className="btn-profile-soft rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-40">Siguiente</button>
      </div>
      {(!step3Valid || !wizardStageABValid) && <p className="mt-2 text-xs text-profile-warn">{modoHerramienta === 'base' ? 'Completa la fecha de cese.' : 'Completa jurisdicción y fecha de cese. Si marcaste que ya posee beneficio, también la fecha de alta. Si aplica docente, completa los datos del cargo.'}</p>}
    </section>
  )
}
